// @ts-nocheck
import { yupResolver } from "@hookform/resolvers/yup";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { env } from "configs/EnvironmentConfig";
import { actionAccess } from "constants/actionAccess";
import { getPhoneValidation } from "constants/validate";
import { formValidate } from "helpers/form_helper";
import {
  CheckActionAccess,
  checkIsHolidayAndNotValidTimelot,
  checkOutSideDateAndTime,
  useQueryRouter,
} from "helpers/utils";
import { useListHolidayWithTime } from "hooks/holiday/useHoliday";
import { isEmpty } from "lodash";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { SingleDatePicker } from "react-dates";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import {
  Button,
  Card,
  Col,
  Form,
  FormGroup,
  InputGroup,
  Label,
  Modal,
  Row,
} from "reactstrap";
import * as yup from "yup";
import UploadForm from "../../../components/shared-components/UploadForm";
import {
  useDetailCustomerLocationByOrder,
  useUploadResource,
} from "../../../hooks";
import "../OrdersForm/OrdersForm.scss";
import LocationCustomerForm from "./CreateLocationCustomerForm";
import SaleSelect from "./SaleSelect";

const isActiveTimeSlot = from_time => {
  const time = moment().hour();
  return from_time.split(":")[0] >= time;
};

const convertObjectToArray = object => {
  if (isEmpty(object)) return [];
  const objectValue = object && Object.keys(object);
  return objectValue.map(item => ({ label: object?.[item], value: item }));
};

const OrderForm = props => {
  let queryRouter = useQueryRouter();
  const { t } = useTranslation(["order"]);
  const {
    buses,
    copiedOrder,
    createOrder,
    customerDetail,
    customers,
    customerShippingType,
    districts,
    locationsCustomer,
    handleChangeCustomer,
    isHCMOrder,
    onKeywordsChange,
    onChangeShippingType,
    onChangeDistrict,
    onChangeProvince,
    onLocationKeywordsChange,
    provinces,
    refetchLocationCustomer,
    wards,
    timeSlots,
    isMyOrder,
    districtAll,
    wardAll,
    onSearchBusChange,
    isCreateOrder,
  } = props;

  const [provinceMenu, setProvinceMenu] = useState(
    convertObjectToArray(provinces)
  );
  const [districtMenu, setDistrictMenu] = useState(
    convertObjectToArray(districts)
  );
  const [wardMenu, setWardMenu] = useState(convertObjectToArray(wards));
  const [districtsDefault, setDistrictsDefault] = useState();
  const [wardsDefault, setWardsDefault] = useState();
  const [isDisabledCollectMoney, setIsDisabledCollectMoney] = useState(false);
  const [isDisableActionDate, setIsDisableActionDate] = useState(false);
  const [, setIsDisableAddCustomerButton] = useState(false);

  let timeSearchBus;
  let timeSearchAddress;
  let timeSearchCustomer;

  const USE_TIME_SLOT_RULE = true;

  useEffect(() => {
    setDistrictsDefault(districtAll);
  }, [districtAll]);
  useEffect(() => {
    setWardsDefault(wardAll);
  }, [wardAll]);

  useEffect(() => {
    setWardMenu(convertObjectToArray(wards));
  }, [wards]);

  useEffect(() => {
    setDistrictMenu(convertObjectToArray(districts));
  }, [districts]);

  useEffect(() => {
    if (isHCMOrder) {
      onChangeProvince?.(env.PROVINCE_CODE_DEFAULT);
      setProvinceMenu(
        convertObjectToArray(provinces).filter(
          ({ value }) => value === env.PROVINCE_CODE_DEFAULT
        )
      );
    } else {
      setProvinceMenu(convertObjectToArray(provinces));
    }
  }, [provinces, isHCMOrder]);

  useEffect(() => {
    if (customerShippingType && customerShippingType.length > 0) {
      setValue("shipping_type", customerShippingType[0], {
        shouldValidate: true,
      });
      handleChangeShippingType(customerShippingType[0]);
    }
  }, [customerShippingType]);

  useLayoutEffect(() => {
    setValue("bus_id", null);
    setValue("shipping_type", null);
  }, []);

  const initDefaultValues = {
    customer_id: null,
    type: 1,
    collect_money: false,
    is_grab: false,
    sender_id: null,
    sender_contact_name: "",
    sender_contact_phone: "",
    sender_address: "",
    sender_ward_code: "",
    sender_district_code: "",
    sender_province_code: "",
    sender_full_address: null,
    transport_id: null,
    runner_id: null,
    bus_id: null,
    shipping_type: null,
    note: "",
    action_date: "",
    timeslot_id: null,
    resourceBill: undefined,
    resourcePackage: undefined,
  };

  const [shippingType, setShippingType] = useState();

  const rulesHCMOrder = isMyOrder
    ? {
        customer_id: yup
          .object()
          .required(
            t("form.validate.select", {
              title: t("form.receiver_contact_name"),
            })
          )
          .nullable(),
        sender_id: yup.string().nullable().required(),
        sender_contact_name: yup.string().required(
          t("form.validate.required", {
            title: t("form.receiver_contact_name"),
          })
        ),
        // sale_id: yup
        //     .object()
        //     .required(
        //         t("form.validate.required", {title: t("form.sale_id")})
        //     )
        //     .nullable(),
        sender_contact_phone: yup
          .string()
          .nullable()
          .required(
            t("form.validate.required", {
              title: t("form.receiver_contact_phone"),
            })
          )
          .matches(
            getPhoneValidation(t).regex,
            getPhoneValidation(t).errorMessage
          )
          .when(getPhoneValidation(t).when),
        sender_full_address: yup
          .object()
          .when((sender_full_address, yupNext) => {
            if (localStorage.getItem("user_type") !== "1") {
              return yupNext.required(
                t("form.validate.select", {
                  title: t("form.receiver_address"),
                })
              );
            }
          })
          .nullable(),
        sender_address: yup
          .string()
          .required(
            t("form.validate.select", { title: t("form.receiver_address") })
          ),
        sender_ward_code: yup
          .object()
          .nullable()
          .required(
            t("form.validate.select", { title: t("form.receiver_ward_code") })
          ),
        sender_district_code: yup
          .object()
          .nullable()
          .required(
            t("form.validate.select", {
              title: t("form.receiver_district_code"),
            })
          ),
        sender_province_code: yup
          .object()
          .nullable()
          .required(
            t("form.validate.select", {
              title: t("form.receiver_province_code"),
            })
          ),
        timeslot_id: yup
          .object()
          .required(t("form.validate.select", { title: t("form.timeslot_id") }))
          .nullable(),
        action_date: yup
          .string()
          .nullable()
          .required(
            t("form.validate.required", { title: t("form.action_date") })
          ),
      }
    : {
        customer_id: yup
          .object()
          .required(
            t("form.validate.select", {
              title: t("form.receiver_contact_name"),
            })
          )
          .nullable(),
        sender_contact_name: yup.string().required(
          t("form.validate.required", {
            title: t("form.receiver_contact_name"),
          })
        ),
        sale_id: yup
          .object()
          .required(t("form.validate.required", { title: t("form.sale_id") }))
          .nullable(),
        sender_contact_phone: yup
          .string()
          .nullable()
          .required(
            t("form.validate.required", {
              title: t("form.receiver_contact_phone"),
            })
          )
          .matches(
            getPhoneValidation(t).regex,
            getPhoneValidation(t).errorMessage
          )
          .when(getPhoneValidation(t).when),
        sender_full_address: yup
          .object()
          .when((sender_full_address, yupNext) => {
            if (localStorage.getItem("user_type") !== "1") {
              return yupNext.required(
                t("form.validate.select", {
                  title: t("form.receiver_address"),
                })
              );
            }
          })
          .nullable(),
        sender_address: yup
          .string()
          .required(
            t("form.validate.select", { title: t("form.receiver_address") })
          ),
        sender_ward_code: yup
          .object()
          .nullable()
          .required(
            t("form.validate.select", { title: t("form.receiver_ward_code") })
          ),
        sender_district_code: yup
          .object()
          .nullable()
          .required(
            t("form.validate.select", {
              title: t("form.receiver_district_code"),
            })
          ),
        sender_province_code: yup
          .object()
          .nullable()
          .required(
            t("form.validate.select", {
              title: t("form.receiver_province_code"),
            })
          ),
        timeslot_id: yup
          .object()
          .required(t("form.validate.select", { title: t("form.timeslot_id") }))
          .nullable(),
        action_date: yup
          .string()
          .nullable()
          .required(
            t("form.validate.required", { title: t("form.action_date") })
          ),
      };

  const rulesDistrictOrder = {
    ...rulesHCMOrder,
    shipping_type: yup
      .object()
      .required(t("form.validate.select", { title: t("form.shipping_type") }))
      .nullable(),
    bus_id: yup
      .object()
      .required(t("form.validate.select", { title: t("form.bus_id") }))
      .nullable(),
  };

  const rulesDistrictOrderShippingType3 = {
    ...rulesDistrictOrder,
    resourceBill: yup.object().nullable(),
    resourcePackage: yup.object().nullable(),
  };

  const rules = isHCMOrder
    ? rulesHCMOrder
    : shippingType === 3
    ? rulesDistrictOrderShippingType3
    : rulesDistrictOrder;
  const isAllowCreate = isMyOrder
    ? CheckActionAccess(actionAccess.GLOG_FUNCTION_MY_ORDER_ADD)
    : CheckActionAccess(actionAccess.GLOG_FUNCTION_ORDER_ADD);
  const schema = yup.object().shape(rules);

  // time-slot menu
  const timeSlotMenuDefault = timeSlots?.map(item => {
    return { label: item?.name, value: item };
  });

  const toInt = string => {
    if (string) {
      return parseInt(string);
    }

    return null;
  };

  const convertTime = value => {
    const formTime = moment(value, "HH:mm:ss");

    const hour = toInt(formTime.format("HH"));
    const minute = toInt(formTime.format("mm"));

    return { hour, minute };
  };

  const getTimeSlot = (timeslot, date, isHCMOrder) => {
    const dateCurrent = moment().startOf("day");
    const dateCollection = moment(date).startOf("day");
    let minValid = 0;
    if (isHCMOrder) {
      minValid = 45;
      const is_grab = getValues("is_grab");
      if (is_grab) {
        minValid = 20;
      }
    }

    const timeValid = moment(Date()).add(minValid, "minute");
    const hourValid = toInt(timeValid.format("HH"));
    const minuteValid = toInt(timeValid.format("mm"));

    if (dateCollection.isSame(dateCurrent) && USE_TIME_SLOT_RULE) {
      return timeslot?.filter(item => {
        if (checkIsHolidayAndNotValidTimelot(holidays?.items, date, item.value))
          return false;

        if (isHCMOrder) {
          if (item?.value?.type == 1) {
            const { hour, minute } = convertTime(item?.value?.from_time);

            return (
              (hour == hourValid && minute >= minuteValid) || hour > hourValid
            );
          } else if (item?.value?.type == 0) {
            const { hour, minute } = convertTime(item?.value?.to_time);

            return (
              (hour == hourValid && minute >= minuteValid) || hour > hourValid
            );
          }
        } else {
          return item?.value?.type == 2;
        }
        return false;
      });
    } else {
      return timeslot?.filter(item => {
        if (checkIsHolidayAndNotValidTimelot(holidays?.items, date, item.value))
          return false;

        if (isHCMOrder) {
          return item?.value?.type == 1 || item?.value?.type == 0;
        } else {
          return item?.value?.type == 2;
        }
      });
    }
  };

  const [timeSlotMenu, setTimeSlotMenu] = useState();
  useEffect(() => {
    setTimeSlotMenu(timeSlotMenuDefault);
  }, [timeSlots]);

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields },
    control,
    watch,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: initDefaultValues,
  });

  const [customersList, setCustomerList] = useState([]);
  const [locationsCustomerList, setLocationsCustomerList] = useState([]);
  const [busList, setBusList] = useState([]);
  const [copiedOrderData, setCopiedOrderData] = useState();
  const [focusedInput, setFocusedInput] = useState(false);
  const [actionDate, setActionDate] = useState();
  const [saleList, setSaleList] = useState([]);

  const onSuccessDetailCustomerLocationByOrder = response => {
    const { data } = response;

    if (data && locationsCustomerList) {
      const locationFind = locationsCustomerList.find(
        x => String(x.value.id) === String(data)
      );

      if (locationFind) {
        setValue("sender_full_address", locationFind, {
          shouldValidate: true,
        });
        onSetSenderAddress(locationFind.value);
        onChangeProvince?.(locationFind.value?.province_code);
        onChangeDistrict?.(locationFind.value?.district_code);
      }
    }
  };
  const {
    isLoading: isLoadingDetailCustomerLocationByOrder,
    mutate: onDetailCustomerLocationByOrder,
  } = useDetailCustomerLocationByOrder({
    onSuccess: onSuccessDetailCustomerLocationByOrder,
  });

  useEffect(() => {
    if (busList && busList.length > 0 && getValues("bus_id") == null) {
      const shippingTypeSelect = getValues("shipping_type");
      // Dvvc là chành xe thì hệ thống không chọn default là giá trị nhà xe đầu tiên.
      if (shippingTypeSelect?.value?.detail?.[0]?.code === "nhaxe") {
        setValue("bus_id", null, { shouldValidate: true });
      } else {
        setValue("bus_id", busList[0], { shouldValidate: true });
      }
    }
  }, [busList]);

  useEffect(() => {
    if (!customers) {
      return;
    }
    const customersUpdated = customers.map(customer => {
      return { label: customer.name, value: customer };
    });
    if (!!copiedOrderData) {
      const optionSelected = customersUpdated.find(
        option => option.value.id === copiedOrderData.customer_id
      );

      if (optionSelected) {
        setValue("customer_id", optionSelected);
        handleChangeCustomer(optionSelected?.value?.id);
      } else if (customerDetail) {
        const newOption = {
          label: customerDetail?.name,
          value: customerDetail,
        };
        customersUpdated.push(newOption);
        setValue("customer_id", newOption);
        handleChangeCustomer(customerDetail?.id);
      }
    }
    setCustomerList(customersUpdated);
  }, [customers, copiedOrderData, customerDetail]);

  useEffect(() => {
    setValue("action_date", moment());
    setActionDate(moment());
    fetchHolidays();
    // if (queryRouter.get("sub_order_codes")) {
    //   setValue("note", queryRouter.get("sub_order_codes"));
    // }
  }, []);

  useEffect(() => {
    if (!!actionDate && !!timeSlots) {
      const timeslot = timeSlots?.map(item => {
        return { label: item?.name, value: item };
      });
      const timeSlot = getTimeSlot(timeslot, actionDate, isHCMOrder);

      setTimeSlotMenu(timeSlot);
      if (!getValues("timeslot_id") && !isHCMOrder) {
        const timeSlotDefault = timeSlots.find(time => time.name === "Cả ngày");
        if (timeSlotDefault) {
          setValue("timeslot_id", { label: "Cả ngày", value: timeSlotDefault });
        }
      }
    }
  }, [actionDate, timeSlots]);

  useEffect(() => {
    if (!locationsCustomer) {
      return;
    }
    // location menu
    const locationMenu =
      Array.isArray(locationsCustomer) &&
      locationsCustomer?.map(
        ({
          id,
          fullAddress,
          contact_name,
          contact_phone,
          address,
          province_code,
          ward_code,
          district_code,
          client_hub_id,
        }) => ({
          label: `${
            client_hub_id ? `Id: ${client_hub_id} - ` : ""
          }${fullAddress} (${contact_name} , ${contact_phone})`,
          value: {
            id: id,
            address: address,
            fullAddress: fullAddress,
            province_code: province_code,
            ward_code: ward_code,
            district_code: district_code,
            contact_name: contact_name,
            contact_phone: contact_phone,
          },
        })
      );
    setLocationsCustomerList(locationMenu);
  }, [locationsCustomer]);

  useEffect(() => {
    const busMenu = buses?.map(bus => {
      return { label: bus.name, value: bus };
    });

    const shippingTypeSelected = watch("shipping_type");
    if (shippingTypeSelected?.label === "Chành xe") {
      setBusList(busMenu);
    }
  }, [buses]);

  const handleChangeShippingType = shippingType => {
    setValue("bus_id", null);
    setShippingType(shippingType?.value?.detail?.[0]?.shipping_type);
    if (shippingType?.value?.detail?.[0]?.shipping_type === 2) {
      const shippingTypes = shippingType?.value?.detail?.map(option => {
        return { label: option?.name, value: option };
      });
      setBusList(shippingTypes);
    } else if (shippingType?.value?.detail?.[0]?.shipping_type === 3) {
      if (buses) {
        const busMenu = buses?.map(bus => {
          return { label: bus.name, value: bus };
        });
        setBusList(busMenu);
      } else
        onChangeShippingType?.(shippingType?.value?.detail?.[0]?.shipping_type);
    }
  };

  useEffect(() => {
    if (!!copiedOrderData && locationsCustomerList?.length > 0) {
      const {
        sender_full_address: fullAddress,
        sender_address: address,
        sender_district_code: districtCode,
        sender_province_code: provinceCode,
        sender_ward_code: wardCode,
        sender_contact_name: contactName,
        sender_contact_phone: contactPhone,
        collect_money: collectMoney,
        id_grab: idGrab,
      } = copiedOrderData;

      onDetailCustomerLocationByOrder({
        id_order: copiedOrder?.id,
      });

      // setValue("sender_full_address", {
      //   label: `${fullAddress}`,
      //   value: {
      //     address: address,
      //     district_code: districtCode,
      //     fullAddress: fullAddress,
      //     province_code: provinceCode,
      //     ward_code: wardCode,
      //     contact_name: contactName,
      //     contact_phone: contactPhone,
      //   },
      // });
      setValue("collect_money", Boolean(collectMoney));
      setValue("id_grab", Boolean(idGrab));
      setValue("sender_address", address);
      setValue("sender_contact_name", contactName);
      setValue("sender_contact_phone", contactPhone);
    }
  }, [copiedOrderData, locationsCustomerList]);

  useEffect(() => {
    if (!!copiedOrderData) {
      const { action_date: actionDate } = copiedOrderData;
      const copiedActionDate = moment(actionDate).startOf("day");
      const currentActionDate = moment(new Date()).startOf("day");
      let action_date = moment();
      let time_slot = null;
      const timeslots = timeSlots?.map(item => {
        return { label: item?.name, value: item };
      });
      if (copiedActionDate.isAfter(currentActionDate)) {
        action_date = moment(actionDate, "YYYY-MM-DD");
        time_slot =
          timeslots?.find(
            item => item?.value?.id === copiedOrderData?.timeSlot?.id
          ) || null;
      } else if (copiedActionDate.isSame(currentActionDate)) {
        action_date = moment(actionDate, "YYYY-MM-DD");
        const check = isActiveTimeSlot(copiedOrderData?.timeSlot?.from_time);
        time_slot = check
          ? timeslots?.find(
              item => item?.value?.id === copiedOrderData?.timeSlot?.id
            )
          : null;
      }
      setValue("action_date", action_date);
      setValue("timeslot_id", time_slot);
      setActionDate(action_date);
    }
  }, [copiedOrderData, timeSlots]);

  useEffect(() => {
    if (!!copiedOrderData) {
      if (!!customerShippingType) {
        const { orderDelivery } = copiedOrderData;
        const { shipping_type: shippingType, transport_id: transportId } =
          orderDelivery;
        const shippingTypeSelected = customerShippingType?.find(
          item => item?.value.detail?.[0].shipping_type === shippingType
        );
        setValue("shipping_type", shippingTypeSelected || null);
        if (shippingType === 2) {
          const shippingTypes = shippingTypeSelected?.value?.detail?.map(
            option => ({ label: option?.name, value: option })
          );
          setBusList(shippingTypes);
          const busSelect = shippingTypes?.find(
            option => option.value.id === transportId
          );
          setValue("bus_id", busSelect);
        } else if (shippingType === 3) {
          onChangeShippingType?.(shippingType);
        }
      }
    }
  }, [copiedOrderData, customerShippingType]);

  useEffect(() => {
    if (!!copiedOrderData) {
      const { orderDelivery } = copiedOrderData;
      const { bus_id: busId } = orderDelivery;
      if (!!busList && getValues("bus_id") === null) {
        const busSelected = busList.find(bus => bus.value.id === busId);
        setValue("bus_id", busSelected || null);
      }
    }
  }, [copiedOrderData, busList]);

  useEffect(() => {
    if (!!copiedOrderData) {
      const { sender_province_code: senderProvinceCode } = copiedOrderData;
      setValue(
        "sender_province_code",
        convertObjectToArray(provinces).find(
          option => option.value === senderProvinceCode
        )
      );
      onChangeProvince?.(senderProvinceCode);
    }
  }, [copiedOrderData, provinces]);

  useEffect(() => {
    if (!!copiedOrderData) {
      const { sender_district_code: senderDistrictCode } = copiedOrderData;
      setValue(
        "sender_district_code",
        convertObjectToArray(districts).find(
          option => option.value === senderDistrictCode
        )
      );
      onChangeDistrict?.(senderDistrictCode);
    }
  }, [copiedOrderData, districts]);

  useEffect(() => {
    if (!!copiedOrderData) {
      const { sender_ward_code: senderWardCode } = copiedOrderData;
      setValue(
        "sender_ward_code",
        convertObjectToArray(wards).find(op => op.value === senderWardCode)
      );
    }
  }, [copiedOrderData, wards]);

  useEffect(() => {
    if (copiedOrder) {
      const { orderDelivery } = copiedOrder;
      const { shipping_type: shippingType } = orderDelivery;
      setCopiedOrderData(copiedOrder);
      onChangeShippingType?.(shippingType);
      Object.keys(copiedOrder).forEach(key => {
        if (key === "note") return;

        setValue(key, copiedOrder[key]);
      });
    }
  }, [copiedOrder]);

  useEffect(() => {
    if (isHCMOrder) {
      setValue(
        "sender_province_code",
        convertObjectToArray(provinces, isHCMOrder).find(
          option => option.value === env.PROVINCE_CODE_DEFAULT
        )
      );
      // hồ chí minh
      onChangeProvince?.(env.PROVINCE_CODE_DEFAULT);
    }
  }, [isHCMOrder, provinces]);

  const [open, setOpenPopup] = useState(false);

  const onSetSenderAddress = value => {
    if (value === null) {
      setValue("sender_full_address", null);
    } else {
      setValue("sender_full_address", {
        label: value.fullAddress,
        value,
      });
    }
    setValue("sender_id", value?.id ? String(value?.id) : null);
    setValue("sender_address", value !== null ? value?.address : "");
    setValue(
      "sender_ward_code",
      value !== null
        ? { label: wardsDefault?.[value?.ward_code], value: value?.ward_code }
        : ""
    );
    setValue(
      "sender_district_code",
      value !== null
        ? {
            label: districtsDefault?.[value?.district_code],
            value: value.district_code,
          }
        : ""
    );
    if (!isHCMOrder && value !== null)
      setValue(
        "sender_province_code",
        provinceMenu.find(x => x.value === value.province_code)
      );
    else if (!isHCMOrder) {
      setValue("sender_province_code", null);
    }

    setValue("sender_contact_name", value !== null ? value.contact_name : "");
    setValue("sender_contact_phone", value !== null ? value.contact_phone : "");

    setError("sender_full_address");
    setError("sender_address");
    setError("sender_ward_code");
    setError("sender_district_code");
    setError("sender_province_code");
    setError("sender_contact_name");
    setError("sender_contact_phone");
  };

  const onSetDaySize = () => {
    if (window.matchMedia("(max-width: 369px)").matches) {
      return 22;
    }
    if (window.matchMedia("(max-width: 450px)").matches) {
      return 24;
    }
    return undefined;
  };

  // ... existing code ...

  const onSubmit = () => {
    const data = getValues();

    // Validate time slot before submitting to prevent expired time slots
    if (data?.timeslot_id && data?.action_date) {
      const timeslot = timeSlots?.map(item => {
        return { label: item?.name, value: item };
      });
      const currentValidTimeSlots = getTimeSlot(
        timeslot,
        data.action_date,
        isHCMOrder
      );

      const isSelectedTimeSlotValid = currentValidTimeSlots.some(
        slot => slot.value.id === data.timeslot_id.value.id
      );

      if (!isSelectedTimeSlotValid) {
        setError("timeslot_id", {
          type: "manual",
          message: "Ca hẹn đã hết hạn, vui lòng chọn ca hẹn khác",
        });
        return;
      }
    }

    const is_grab = data?.is_grab ? 1 : 0;
    const collect_money = data?.collect_money ? 1 : 0;
    const shipping_type =
      data?.shipping_type?.value?.detail?.[0]?.shipping_type;
    const transport_id = shipping_type === 2 ? data?.bus_id?.value?.id : null;
    const bus_id = shipping_type === 3 ? data?.bus_id?.value?.id : null;
    const action_date = data?.action_date
      ? moment(data?.action_date).format("YYYY-MM-DD")
      : null;
    const sale_id = data.sale_id ? data.sale_id.value : null;
    const order = {
      customer_id: data?.customer_id.value.id,
      customer_code: data?.customer_id.value.code,
      type: 2,
      collect_money: isHCMOrder ? collect_money : null,
      is_grab: isHCMOrder ? is_grab : null,
      customer_location_id: data?.sender_id,
      customer_contact_name: data?.sender_contact_name,
      customer_contact_phone: data?.sender_contact_phone,
      customer_address: data?.sender_address,
      customer_ward_code: data?.sender_ward_code?.value,
      customer_district_code: data?.sender_district_code?.value,
      customer_province_code: data?.sender_province_code?.value,
      transport_id: transport_id,
      runner_id: null,
      bus_id: bus_id,
      shipping_type: isHCMOrder ? "1" : shipping_type,
      note: data?.note,
      action_date: action_date,
      timeslot_id: data?.timeslot_id?.value?.id,
      sale_id: sale_id,
      resources: { bill: [resourceBillId], package: [resourcePackageId] },
      sub_order_codes: queryRouter.get("sub_order_codes")
        ? queryRouter.get("sub_order_codes").split(",")
        : undefined,
    };

    createOrder?.(order);
  };

  const handleChangeProvince = province => {
    setValue("sender_province_code", province);
    setValue("sender_district_code", null);
    setValue("sender_ward_code", null);
    onChangeProvince?.(province?.value);
  };

  const handleChangeDistrict = district => {
    setValue("sender_district_code", district);
    setValue("sender_ward_code", null);
    onChangeDistrict?.(district?.value);
  };

  const handleChangeGrab = grab => {
    const is_grab = !getValues("is_grab");
    const timeslot = timeSlots?.map(item => {
      return { label: item?.name, value: item };
    });
    let timeSlot = getTimeSlot(timeslot, actionDate, isHCMOrder);

    if (is_grab) {
      setValue("collect_money", false);
      setValue("is_grab", true);
      setActionDate(moment());
      timeSlot = getTimeSlot(timeslot, moment(), isHCMOrder);
      setIsDisabledCollectMoney(true);
      setIsDisableActionDate(true);
    } else {
      setValue("is_grab", false);
      setIsDisabledCollectMoney(false);
      setIsDisableActionDate(false);
    }

    const timeslot_id = getValues("timeslot_id");
    const isFindTimeSlotId = timeSlot.find(
      time => time?.value?.id == timeslot_id?.value?.id
    );
    if (timeslot_id && !isFindTimeSlotId) {
      setValue("timeslot_id", null);
    }
    setTimeSlotMenu(timeSlot);
  };

  const onUploadBillSuccess = response => {
    if (response?.data?.id) {
      setResourceBillId(response?.data?.id);
    }
  };

  const onUploadPackageSuccess = response => {
    if (response?.data?.id) {
      setResourcePackageId(response?.data?.id);
    }
  };

  const [resourceBillId, setResourceBillId] = useState(null);
  const [resourcePackageId, setResourcePackageId] = useState(null);

  const { mutate: uploadResourceBill } = useUploadResource(onUploadBillSuccess);
  const { mutate: uploadResourcePackage } = useUploadResource(
    onUploadPackageSuccess
  );

  const onRemoveFileBill = res => {
    setValue("resourceBill", undefined);
    setResourceBillId(null);
  };

  const handleFilesBill = files => {
    if (files.length > 0) {
      const data = new FormData();
      data.append("file", files[0]);
      setValue("resourceBill", {}, { shouldValidate: true });
      uploadResourceBill(data);
    }
  };

  const onRemoveFilePackage = res => {
    setValue("resourcePackage", undefined);
    setResourceBillId(null);
  };

  const handleFilesPackage = files => {
    if (files.length > 0) {
      const data = new FormData();
      data.append("file", files[0]);
      setValue("resourcePackage", {}, { shouldValidate: true });
      uploadResourcePackage(data);
    }
  };

  const {
    data: holidays,
    isFetching: isLoadingList,
    refetch: fetchHolidays,
  } = useListHolidayWithTime({
    params: {
      sizePerPage: 10,
      page: -1,
      sort: "-maker_date",
      columnFilter: {},
      keywords: "",
      columnsVisible: {},
      fields: "",
      expand: "",
    },
    useToDisalbeCalendar: true,
    queryKey: "holiday-list-order-with-time",
  });

  useEffect(() => {
    console.log("🚀 ~ file: OrdersForm.js:1013 ~ useEffect ~ errors:", errors);
  }, [errors]);

  const isAnyShift = date => {
    const timeslot = timeSlots?.items?.map(item => {
      return { label: item?.name, value: item };
    });
    const timeSlot = getTimeSlot(timeslot, date, isHCMOrder);
    return timeSlot && timeSlot.length > 0;
  };

  return (
    <Card body className="order-form" style={{ marginBottom: "150px" }}>
      <Form>
        <Row md={1}>
          <Col>
            {!isMyOrder && (
              <Row xs={1} md={2}>
                <Col>
                  <FormGroup className="gy-2">
                    <Label htmlFor="customer_id">
                      {t("form.customer")}{" "}
                      <span className="text-danger">*</span>
                    </Label>
                    <Controller
                      control={control}
                      name="customer_id"
                      render={({ field }) => (
                        <Select
                          {...field}
                          placeholder={t("placeholder.select", {
                            title: t("form.customer"),
                          })}
                          options={customersList}
                          classNamePrefix="select"
                          isSearchable
                          className="basic-single w-100"
                          onChange={data => {
                            field.onChange(data);
                            onSetSenderAddress(null);
                            setValue("sale_id", null);
                            handleChangeCustomer(data.value.id);
                          }}
                          onInputChange={(keywords, actions) => {
                            clearTimeout(timeSearchCustomer);
                            timeSearchCustomer = setTimeout(() => {
                              if ((actions.action = "input-change")) {
                                if (keywords) {
                                  onKeywordsChange?.(
                                    keywords.trim().replaceAll(" ", "+")
                                  );
                                } else {
                                  onKeywordsChange?.("");
                                }
                              }
                            }, 500);
                          }}
                          onBlur={() => onKeywordsChange?.("")}
                        />
                      )}
                    />
                    {errors.customer_id && (
                      <MessageFormValidate error={errors.customer_id.message} />
                    )}
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup className="gy-2">
                    <Label htmlFor="sale_id">
                      {t("form.sale_id")} <span className="text-danger">*</span>
                    </Label>
                    <Controller
                      control={control}
                      name="sale_id"
                      render={({ field }) => (
                        <SaleSelect
                          {...field}
                          customerId={watch("customer_id")?.value.id}
                          setSale={setValue}
                          isSearchable
                          // isDisabled={!watch("province_code")}
                          onChange={e => {
                            setValue("sale_id", e, { shouldValidate: true });
                          }}
                        />
                      )}
                    />
                    {errors.sale_id && (
                      <MessageFormValidate error={errors.sale_id.message} />
                    )}
                  </FormGroup>
                </Col>
              </Row>
            )}
            {isMyOrder && (
              <FormGroup className="gy-2">
                <Label htmlFor="customer_id">
                  {t("form.customer")} <span className="text-danger">*</span>
                </Label>
                <Controller
                  control={control}
                  name="customer_id"
                  render={({ field }) => (
                    <Select
                      {...field}
                      placeholder={t("placeholder.select", {
                        title: t("form.customer"),
                      })}
                      options={customersList}
                      classNamePrefix="select"
                      isSearchable
                      className="basic-single w-100"
                      onChange={data => {
                        field.onChange(data);
                        onSetSenderAddress(null);
                        setBusList([]);
                        handleChangeCustomer(data.value.id);
                      }}
                      onInputChange={(keywords, actions) => {
                        clearTimeout(timeSearchCustomer);
                        timeSearchCustomer = setTimeout(() => {
                          if (actions.action == "input-change") {
                            if (keywords) {
                              onKeywordsChange?.(
                                keywords.trim().replaceAll(" ", "+")
                              );
                            } else {
                              onKeywordsChange?.("");
                            }
                          }
                        }, 500);
                      }}
                      onBlur={() => onKeywordsChange?.("")}
                    />
                  )}
                />
                {errors.customer_id && (
                  <MessageFormValidate error={errors.customer_id.message} />
                )}
              </FormGroup>
            )}

            <Row xs={1} md={2}>
              <Col>
                <FormGroup>
                  <Label htmlFor="address_order">
                    {t("form.position_pick_order")}{" "}
                    <span className="text-danger">*</span>
                  </Label>
                  <InputGroup style={{ flexWrap: "unset" }}>
                    <Controller
                      control={control}
                      name="sender_full_address"
                      render={({ field }) => (
                        <Select
                          {...field}
                          placeholder={t("placeholder.select", {
                            title: t("form.receiver_address"),
                          })}
                          className="basic-single w-100"
                          classNamePrefix="select"
                          options={locationsCustomerList}
                          onChange={data => {
                            field.onChange(data);
                            onSetSenderAddress(data.value);
                            onChangeProvince?.(data.value?.province_code);
                            onChangeDistrict?.(data.value?.district_code);
                          }}
                          required
                          isDisabled={isLoadingDetailCustomerLocationByOrder}
                          isSearchable
                          onInputChange={(keywords, actions) => {
                            clearTimeout(timeSearchAddress);
                            timeSearchAddress = setTimeout(() => {
                              if (actions.action == "input-change") {
                                if (keywords) {
                                  onLocationKeywordsChange?.(
                                    keywords.trim().replaceAll(" ", "+")
                                  );
                                } else {
                                  onLocationKeywordsChange?.("");
                                }
                              }
                            }, 500);
                          }}
                          onBlur={() => onLocationKeywordsChange?.("")}
                        />
                      )}
                    />
                    {!busList?.some(b => b?.value?.code === "cpn247") && (
                      <Button
                        style={{ backgroundColor: "#3C64B1", zIndex: 0 }}
                        color="primary"
                        disabled={
                          String(watch("bus_id.value.id")) === "9" && isMyOrder
                        }
                        onClick={() => {
                          if (getValues("customer_id")) setOpenPopup(!open);
                          else
                            setError(
                              "customer_id",
                              { type: "focus" },
                              { shouldFocus: true }
                            );
                        }}
                      >
                        {t("button.add")}
                      </Button>
                    )}

                    <Modal
                      isOpen={open}
                      centered
                      toggle={() => {
                        setOpenPopup(!open);
                      }}
                    >
                      <LocationCustomerForm
                        isHCMOrder={isHCMOrder}
                        handleCancel={() => {
                          refetchLocationCustomer?.();
                          setOpenPopup(false);
                        }}
                        provinces={provinces}
                        districts={districts}
                        wards={wards}
                        customer_id={getValues("customer_id")?.value?.id}
                        onChangeProvince={onChangeProvince}
                        onChangeDistrict={onChangeDistrict}
                      />
                    </Modal>
                  </InputGroup>
                  {errors.sender_full_address && (
                    <MessageFormValidate
                      error={errors.sender_full_address.message}
                    />
                  )}
                </FormGroup>
                <Row xs={1} md={2}>
                  <Col>
                    <FormGroup>
                      <Label
                        htmlFor="sender_address"
                        className="visually-hidden"
                      >
                        {t("form.receiver_address")}
                      </Label>
                      <input
                        className={`form-control`}
                        id="sender_address"
                        type="text"
                        placeholder={t("placeholder.enter", {
                          title: t("form.receiver_address"),
                        })}
                        {...register("sender_address")}
                      />
                      {errors.sender_address && (
                        <MessageFormValidate
                          error={errors.sender_address.message}
                        />
                      )}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label
                        htmlFor="sender_ward_code"
                        className="visually-hidden"
                      >
                        {t("form.receiver_ward_code")}
                      </Label>
                      <Controller
                        control={control}
                        name="sender_ward_code"
                        render={({ field }) => (
                          <Select
                            {...field}
                            placeholder={t("placeholder.select", {
                              title: t("form.receiver_ward_code"),
                            })}
                            options={wardMenu}
                            isSearchable
                            isDisabled={!getValues("sender_district_code")}
                            className="basic-single w-100"
                            classNamePrefix="select"
                          />
                        )}
                      />
                      {errors.sender_ward_code && (
                        <MessageFormValidate
                          error={errors.sender_ward_code.message}
                        />
                      )}
                    </FormGroup>
                  </Col>
                  {sender_full_address?.value?.is_new_address === "O" && (
                    <Col>
                      <FormGroup>
                        <Label
                          htmlFor="sender_district_code"
                          className="visually-hidden"
                        >
                          {t("form.receiver_district_code")}
                        </Label>
                        <Controller
                          control={control}
                          name="sender_district_code"
                          render={({ field }) => (
                            <Select
                              {...field}
                              placeholder={t("placeholder.select", {
                                title: t("form.receiver_district_code"),
                              })}
                              options={districtMenu}
                              isSearchable
                              className="basic-single w-100"
                              classNamePrefix="select"
                              isDisabled={
                                !getValues("sender_province_code") ||
                                isFetchingLocationTransports ||
                                !!sender_full_address
                              }
                              onChange={handleChangeDistrict}
                            />
                          )}
                        />
                        {errors.sender_district_code && (
                          <MessageFormValidate
                            error={errors.sender_district_code.message}
                          />
                        )}
                      </FormGroup>
                    </Col>
                  )}
                  <Col>
                    <FormGroup>
                      <Label
                        htmlFor="sender_province_code"
                        className="visually-hidden"
                      >
                        {t("form.receiver_province_code")}
                      </Label>

                      <Controller
                        control={control}
                        name="sender_province_code"
                        render={({ field }) => (
                          <Select
                            {...field}
                            placeholder={t("placeholder.select", {
                              title: t("form.receiver_province_code"),
                            })}
                            options={provinceMenu}
                            isSearchable
                            className="basic-single w-100"
                            classNamePrefix="select"
                            onChange={handleChangeProvince}
                            isDisabled={isHCMOrder}
                          />
                        )}
                      />
                      {errors.sender_province_code && (
                        <MessageFormValidate
                          error={errors.sender_province_code.message}
                        />
                      )}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label
                        htmlFor="sender_contact_name"
                        className="visually-hidden"
                      >
                        {t("form.receiver_contact_name")}
                      </Label>
                      <input
                        type="text"
                        id="sender_contact_name"
                        placeholder={t("placeholder.enter", {
                          title: t("form.receiver_contact_name"),
                        })}
                        className={`form-control `}
                        {...register("sender_contact_name")}
                      />
                      {errors.sender_contact_name && (
                        <MessageFormValidate
                          error={errors.sender_contact_name.message}
                        />
                      )}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label
                        htmlFor="sender_contact_phone"
                        className="visually-hidden"
                      >
                        {t("form.receiver_contact_phone")}
                      </Label>
                      <input
                        type="number"
                        id="sender_contact_phone"
                        placeholder={t("placeholder.enter", {
                          title: t("form.receiver_contact_phone"),
                        })}
                        className={`form-control`}
                        {...register("sender_contact_phone")}
                      />
                      {errors.sender_contact_phone && (
                        <MessageFormValidate
                          error={errors.sender_contact_phone.message}
                        />
                      )}
                    </FormGroup>
                  </Col>
                </Row>
                <Label htmlFor="orderTime">
                  {t("form.timeslot_id")} <span className="text-danger">*</span>
                </Label>
                <Row xs={1} md={2}>
                  {isHCMOrder ? (
                    <Col>
                      <FormGroup>
                        <div
                          className="d-flex align-items-center action_date_input"
                          style={{ backgroundColor: "#f4f5f4" }}
                        >
                          <span
                            style={{ paddingLeft: "12px" }}
                            className="prefix"
                          >
                            {t("form.action_date_label")}
                          </span>
                          <Controller
                            control={control}
                            name="action_date"
                            render={({ field }) => (
                              <SingleDatePicker
                                {...field}
                                date={actionDate}
                                onDateChange={date => {
                                  setValue("action_date", date);
                                  setActionDate(date);
                                  setError("action_date");
                                  setValue("timeslot_id", null);
                                }}
                                focused={focusedInput}
                                onFocusChange={({ focused }) =>
                                  setFocusedInput(focused)
                                }
                                isOutsideRange={date => {
                                  return (
                                    !isAnyShift(date) ||
                                    checkOutSideDateAndTime(
                                      date,
                                      holidays?.items
                                    )
                                  );
                                }}
                                displayFormat="DD/MM/YYYY"
                                numberOfMonths={1}
                                small
                                placeholder=""
                                showDefaultInputIcon
                                inputIconPosition="after"
                                readOnly
                                daySize={onSetDaySize()}
                                disabled={isDisableActionDate}
                              />
                            )}
                          />
                        </div>
                        {errors.action_date && (
                          <MessageFormValidate
                            error={errors.action_date.message}
                          />
                        )}
                      </FormGroup>
                    </Col>
                  ) : null}
                  <Col>
                    <FormGroup>
                      <Label htmlFor="orderHour" className="visually-hidden" />
                      <Controller
                        control={control}
                        name="timeslot_id"
                        render={({ field }) => (
                          <Select
                            {...field}
                            placeholder={t("placeholder.select", {
                              title: t("form.timeslot_id"),
                            })}
                            id="orderHour"
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable
                            options={timeSlotMenu}
                            isDisabled={!getValues("action_date")}
                          />
                        )}
                      />
                      {errors.timeslot_id && (
                        <MessageFormValidate
                          error={errors.timeslot_id.message}
                        />
                      )}
                    </FormGroup>
                  </Col>
                  {isHCMOrder && (
                    <>
                      <Col>
                        <FormGroup
                          className="orders-card d-flex align-items-center"
                          style={{ padding: "12px" }}
                        >
                          <input
                            disabled={isDisabledCollectMoney}
                            name="get-money"
                            type="checkbox"
                            className="mt-0"
                            {...register("collect_money")}
                          />
                          <Label
                            check
                            htmlFor="get-money"
                            style={{
                              marginLeft: "8px",
                              fontWeight: "400",
                            }}
                          >
                            {t("form.collect_money")}
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup
                          className="orders-card d-flex align-items-center"
                          style={{ padding: "12px" }}
                        >
                          <input
                            name="is-grab"
                            type="checkbox"
                            className="mt-0"
                            {...register("is_grab")}
                            onChange={handleChangeGrab}
                          />
                          <Label
                            check
                            htmlFor="is-grab"
                            style={{
                              marginLeft: "8px",
                              fontWeight: "400",
                            }}
                          >
                            {t("form.is_grab")}
                          </Label>
                        </FormGroup>
                      </Col>
                    </>
                  )}
                </Row>
                {!isHCMOrder && (
                  <>
                    <Label htmlFor="shipping_type">
                      {t("form.shipping_type")}{" "}
                      <span className="text-danger">*</span>
                    </Label>
                    {getValues("customer_id") !== null &&
                      customerShippingType?.length === 0 && (
                        <MessageFormValidate
                          error={t("message.no_customer_shipping_type")}
                        />
                      )}
                    <Row xs={1} md={2}>
                      <Col>
                        <FormGroup>
                          <Controller
                            control={control}
                            name="shipping_type"
                            render={({ field }) => (
                              <Select
                                {...field}
                                placeholder={t("placeholder.select", {
                                  title: t("form.shipping_type"),
                                })}
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable
                                options={customerShippingType}
                                onChange={data => {
                                  field.onChange(data);
                                  handleChangeShippingType(data);
                                }}
                              />
                            )}
                          />
                          {errors.shipping_type && (
                            <MessageFormValidate
                              error={errors.shipping_type.message}
                            />
                          )}
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label htmlFor="bus_id" className="visually-hidden" />
                          <Controller
                            control={control}
                            name="bus_id"
                            render={({ field }) => (
                              <Select
                                {...field}
                                placeholder={t("placeholder.select", {
                                  title: t("form.bus_id"),
                                })}
                                id="bus_id"
                                className="basic-single"
                                classNamePrefix="select"
                                options={busList}
                                onChange={value => {
                                  field.onChange(value);

                                  setIsDisableAddCustomerButton(
                                    String(value?.value?.id) === "9"
                                  );
                                }}
                                onInputChange={(keywords, actions) => {
                                  clearTimeout(timeSearchBus);
                                  timeSearchBus = setTimeout(
                                    () =>
                                      onSearchBusChange({ keywords, actions }),
                                    500
                                  );
                                }}
                                onBlur={e =>
                                  onSearchBusChange({
                                    keywords: "",
                                    actions: { action: "input-change" },
                                  })
                                }
                              />
                            )}
                          />
                          {errors.bus_id && (
                            <MessageFormValidate
                              error={errors.bus_id.message}
                            />
                          )}
                        </FormGroup>
                      </Col>
                      {shippingType === 3 ? (
                        <Col>
                          <FormGroup className="mb-3">
                            <Label htmlFor="avatar">
                              {t("form.upload_bill")}
                            </Label>
                            <UploadForm
                              removeFile={onRemoveFileBill}
                              multiple={false}
                              handleFiles={files => handleFilesBill(files)}
                              accept=".jpg"
                            ></UploadForm>
                            <input
                              style={{ display: "none" }}
                              {...register("resourceBill")}
                            ></input>
                            {errors.resourceBill && (
                              <MessageFormValidate
                                error={errors.resourceBill.message}
                              />
                            )}
                          </FormGroup>
                        </Col>
                      ) : null}
                      {shippingType === 3 ? (
                        <Col>
                          <FormGroup className="mb-3">
                            <Label htmlFor="avatar">
                              {t("form.upload_package")}
                            </Label>
                            <UploadForm
                              removeFile={onRemoveFilePackage}
                              multiple={false}
                              handleFiles={files => handleFilesPackage(files)}
                              accept=".jpg"
                            ></UploadForm>
                            <input
                              style={{ display: "none" }}
                              {...register("resourcePackage")}
                            ></input>
                            {errors.resourcePackage && (
                              <MessageFormValidate
                                error={errors.resourcePackage.message}
                              />
                            )}
                          </FormGroup>
                        </Col>
                      ) : null}
                    </Row>
                  </>
                )}
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="note">{t("form.note")}</Label>
                  <textarea
                    type="textarea"
                    className={`form-control ${formValidate(
                      errors,
                      touchedFields,
                      "note"
                    )}`}
                    name="note"
                    placeholder={t("placeholder.note")}
                    rows={9}
                    {...register("note")}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Col>
          <Col xs={12} md={6}>
            <Row xs={2}>
              <Col>
                <Button
                  color="danger"
                  outline
                  className="border-0"
                  size="xs"
                  onClick={() => handleCancel()}
                >
                  {t("button.cancel")}
                </Button>
              </Col>
              {isAllowCreate && (
                <Col className="text-end">
                  <Button
                    disabled={
                      isCreateOrder || isLoadingDetailCustomerLocationByOrder
                    }
                    size="xs"
                    color="primary"
                    style={{ backgroundColor: "#3C64B1" }}
                    onClick={() => {
                      handleSubmit(onSubmit)();
                    }}
                  >
                    {t("button.confirm")}
                  </Button>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

OrderForm.propTypes = {
  isHCMOrder: PropTypes.bool,
  customers: PropTypes.array,
  timeSlots: PropTypes.array,
  buses: PropTypes.array,
  locationsCustomer: PropTypes.array,
  handleChangeCustomer: PropTypes.func,
  provinces: PropTypes.object,
  districts: PropTypes.object,
  wards: PropTypes.object,
  createOrder: PropTypes.func,
  refetchLocationCustomer: PropTypes.func,
  onChangeProvince: PropTypes.func,
  onChangeDistrict: PropTypes.func,
  onKeywordsChange: PropTypes.func,
  onChangeShippingType: PropTypes.func,
  handleCancel: PropTypes.func,
  onLocationKeywordsChange: PropTypes.func,
  customerShippingType: PropTypes.array,
  copiedOrder: PropTypes.object,
  customerDetail: PropTypes.object,
  isMyOrder: PropTypes.bool,
  districtAll: PropTypes.object,
  wardAll: PropTypes.object,
  onSearchBusChange: PropTypes.func,
  isCreateOrder: PropTypes.bool,
};
export default OrderForm;
